import router from "../../router"
import { getToken } from "../../utils/auth"
import { useReLogin } from "../../hooks/useAuth"

export function reqResolve(config) {
  if (!config.ignoreToken) {
    const token = getToken()
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJleHAiOjE3NjEyNzE3NjIsImNvbnRlbnQiOnsibG9naW5UaW1lIjoxNzU4Njc5NzYyMjQ5LCJzZXNzaW9uS2V5IjoidGFsMTczQUZIRk9xdTdCLV9fNC1sOU9iMGh4eEttSEs0ODhrOUZCeVpYTGpEM0trS2dBSmdnMUN6eV95Ykp6Z01PNjRaclJMYVZBTS1UX2RJeFVTeDVpWkw3elpRTXJCUUd3bFNTYm9oZkF0M054cUxydk1fdnRLMV9Mb1ZaaWhLWkZBU1hndnY2Y0NJUUhzOTVqMEFaOXN4bDA3cmh1OE1GS2E3SFlwY0FJNGpUX1FjZ2YiLCJvcGVuSWQiOiJvb2tFUzBkNFA5SFltWUpYTUYxOFpScGNFeEVvIiwiY2hhbm5lbCI6InRhbF9tcCIsInRhbElkIjoiVGFsb3FKNExUZDVfYThtXzVmUVg1ZGpUQ3ciLCJ0eXBlIjoxLCJ1c2VySWQiOiIxYzQzZDVlZGVmZDg0ZTQ5OWUzZDczYjRlZjZlYTUwZCJ9fQ.iDqUDXmzfEhGHXb07pahD-5k6LWyOGC3QcYrAR9D8T8v-Qfr3-XwpABhcpSukMs553Vl3lMIOeuXK3EpcCAR6TXkArmFD6Ym_ZO8wIxHTFsai6LmdoHhR13YLm-sBrShdRrhmyTfsUfEuPAUjttXOJh1dH6fuZkRkQZSDNbJipg'
    config.headers.JWT = token
  }
  return config
}

export function reqReject(error) {
  return Promise.reject(error)
}

export function resResolve(response) {
  const { status, data } = response
  if (status === 401 && router.currentRoute.value.name !== 'login') {
    useReLogin()
    return
  }
  return Promise.resolve(data)
}

export function resReject(error) {
  return Promise.reject(error)
}